class CartNotesForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form']
  }

  constructor () {
    super()

    this.form = this.querySelector('form')
    this.isRefreshing = false
  }

  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.form.addEventListener('submit', this.handleSubmit.bind(this))
  }

  handleSubmit (e) {
    e.preventDefault()

    if (this.isRefreshing) return

    const submitterId = e.submitter?.id
    const textarea = this.form.querySelector('textarea[name="note"]')
    const newNoteValue =
      submitterId === 'ClearCartNote' ? '' : textarea?.value ?? ''

    this.updateNoteAndRefresh(newNoteValue)
  }

  async updateNoteAndRefresh (noteValue) {
    try {
      this.isRefreshing = true
      this.classList.add('psh-CartFooter_NotesForm-loading')

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: noteValue }),
      })

      if (!response.ok) {
        throw new Error('Failed to update cart note')
      }

      // eslint-disable-next-line no-unused-vars
      const _data = await response.json()

      await this.refreshPushCart()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      this.isRefreshing = false
      this.classList.remove('psh-CartFooter_NotesForm-loading')
    }
  }

  async refreshPushCart () {
    const renderer = window?.BAO?.sectionRenderer
    if (!renderer) return

    const pushCartSections = renderer.pushCartSections
    const sectionNames = [...new Set(pushCartSections.map((s) => s.section))]

    const htmlSections = await renderer.fetch(sectionNames)

    const sections = pushCartSections.map((section) => ({
      id: section.id,
      selector: section.selector,
      html: htmlSections[section.section],
    }))

    renderer.renderMultiple(sections)
  }
}

window.customElements.define('cart-notes-form', CartNotesForm)
